import { createContext } from 'react';
import { UseDisclosureResult } from '../../../lib/hooks';

export const AddPasswordPanelContext = createContext<UseDisclosureResult | undefined>(undefined);
